import { render, staticRenderFns } from "./GravityViz.vue?vue&type=template&id=111c4ee3&scoped=true"
import script from "./GravityViz.vue?vue&type=script&lang=js"
export * from "./GravityViz.vue?vue&type=script&lang=js"
import style0 from "./GravityViz.vue?vue&type=style&index=0&id=111c4ee3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111c4ee3",
  null
  
)

export default component.exports